import { render, staticRenderFns } from "./paymentCancled.vue?vue&type=template&id=310025b7&"
import script from "./paymentCancled.vue?vue&type=script&lang=js&"
export * from "./paymentCancled.vue?vue&type=script&lang=js&"
import style0 from "./paymentCancled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports